import React from "react";
import { BsArrowUpCircle } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { GiNotebook } from "react-icons/gi";
import { RiLinkedinLine } from "react-icons/ri";
import { VscMail } from "react-icons/vsc";
import { RiTwitterXLine } from "react-icons/ri";
import { SiUpwork } from "react-icons/si";
import { AiOutlineCopyrightCircle } from "react-icons/ai";
import { useState, useRef } from "react";
import { Fade } from "react-awesome-reveal";
import FormModal from "./FormModal";
import SentModal from "./SentModal";
import ErrorModal from "./ErrorModal";
import { scrollToTop } from "../utils/lenisScroll";
import { hapticSuccess, hapticError } from "../utils/haptics";

const Footer = () => {
  const [showModal, setShowModal] = useState(false);

  const [sentModal, setSentModal] = useState(false);

  const [errorMsg, setErrorMsg] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const openBtn = () => {
    setShowModal((prevState) => !prevState);
  };

  const sentModalClose = () => {
    setShowModal(false);
    window.location.reload(false);
  };

  const closeErrorModal = () => {
    setErrorMsg(false);
  };

  const form = useRef();

  // Sends the form to /api/contact (Resend), same approach as the Tranzent site.
  // The visitor's email is set as reply-to server-side, so Reply goes straight to them.
  const sendEmail = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const data = Object.fromEntries(new FormData(form.current).entries());

      const response = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (!response.ok) throw new Error("Request failed");

      hapticSuccess();
      openBtn();
      setSentModal(true);
    } catch (error) {
      hapticError();
      setErrorMsg(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <footer className="footer bg-[#bb4025]">
      <section id="contact" className="navB">
        <div className="footer-container pb-[8rem] px-6 py-[4rem] lg:py-[5rem] lg:px-[2.5rem] lg:h-[37.5rem] mb-0 xl:h-[43.75rem] xl:py-[7rem] w-full xl:px-[4rem] max-w-[90rem] mx-auto relative">
          <div className="back-to-top absolute top-[2rem] right-[1.5rem] lg:top-[2.5rem] lg:right-[2.5rem] xl:top-[4rem] xl:right-[4rem] left-auto">
            <button onClick={scrollToTop} aria-label="Scroll to top" id="back-to-top">
              <BsArrowUpCircle size='2rem' className="rounded-[100%] hover:border-white hover:border-2 hover:bg-white hover:text-[#bb4025] hover:transition-colors hover:duration-300" />
            </button>
          </div>
          <Fade direction="up" triggerOnce={true} fraction={1}>
            <h3 className="footer-heading text-[2.75rem] mb-[4rem] tracking-[-.25rem] leading-[3.375rem] md:text-[3.125] md:leading-[3.375rem] lg:mb-[5rem] lg:text-[3.75rem] lg:leading-[3.375rem] xl:mb-[4rem] xl:text-[4.375rem] xl:leading-[5rem]">
              Contact
            </h3>
          </Fade>
          <Fade direction="up" triggerOnce={true} fraction={1}>
            <div className="contact-msg text-[1.125rem] leading-[1.75rem] md:text-[1.25rem] md:leading-[1.875rem] lg:text-[1.375rem] lg:leading-[2rem] xl:max-w-[42rem] mb-[3rem] xl:mb-[5rem] group">
              <h3 className="font-semibold text-[1.5rem] leading-tight mb-3">
                Let's Build Something People Love Using
              </h3>

              <p className="mb-6">

                If you're building something new, making an existing product better, or searching for a frontend engineer who genuinely cares about product vision, let's chat.
              </p>

              <p className="">
                <span>Start a conversation using this</span>
                <span className="inline-flex">
                  <button
                    className="form-link ml-1 border-b border-[#e5e5e5] hover:text-[#ffb49a] hover:border-[#ffb49a] font-medium"
                    onClick={openBtn}
                  >
                    form
                  </button>
                  <GiNotebook
                    size="1.75rem"
                    className="ml-2 border rounded-full p-1 animate-pulse group-hover:text-[#ffb49a] group-hover:animate-none"
                  />
                </span>
              </p>
            </div>

          </Fade>
          <div className="contact-links flex flex-col gap-y-[1rem] md:flex-row md:flex-wrap md:gap-x-[2rem] lg:gap-x-[2.5rem] xl:gap-x-[4rem]">
            <Fade
              direction="up"
              cascade
              damping={0.1}
              triggerOnce={true}
              fraction={1}
            >
              <div className="mails-group ">
                <div className="email-contact flex items-center gap-2 text-[1.25rem] md:text-[1.375rem] leading-[1.625rem] md:leading-[1.875rem] lg:text-[1.5rem] lg:leading-[2rem] xl:leading-[2rem] hover:text-[#ffb49a] cursor-pointer w-fit">
                  <a href="mailto:emuobopleasure@outlook.com"
                    className="transition-colors duration-200"
                  >
                    emuobopleasure@outlook.com
                  </a>
                  <VscMail
                    size="2rem"
                    className="border rounded-[100%] p-[5px]"
                  />
                </div>
              </div>
              <a
                href="https://github.com/emuobopleasure"
                target="_blank" rel="noopener noreferrer"
                className="github-url"
              >
                <div className="github-profile inline-flex items-center gap-2 text-[1.25rem] md:text-[1.375rem] leading-[1.625rem] md:leading-[1.875rem] lg:text-[1.5rem] lg:leading-[2rem] xl:leading-[2rem] hover:text-[#ffb49a]">
                  <p>GitHub</p>
                  <FaGithub
                    size="2rem"
                    className="linkedin-icon border rounded-[100%] p-[5px]"
                  />
                </div>
              </a>
              <a
                href="https://www.linkedin.com/in/emuobonuviepleasure/"
                target="_blank" rel="noopener noreferrer"
                className="linkedIn-url w-fit"
              >
                <div className="linkedin-profile inline-flex items-center gap-2 text-[1.25rem] md:text-[1.375rem] leading-[1.625rem] md:leading-[1.875rem] lg:text-[1.5rem] lg:leading-[2rem] xl:leading-[2rem] hover:text-[#ffb49a]">
                  <p>LinkedIn</p>
                  <RiLinkedinLine
                    size="2rem"
                    className="linkedin-icon border rounded-[100%] p-[5px]"
                  />
                </div>
              </a>
              <a
                href="https://x.com/emuobodavis"
                target="_blank" rel="noopener noreferrer"
                className="x-url w-fit"
              >
                <div className="twitter-profile inline-flex items-center gap-2 text-[1.25rem] md:text-[1.375rem] leading-[1.625rem] md:leading-[1.875rem] lg:text-[1.5rem] lg:leading-[2rem] xl:leading-[2rem] hover:text-[#ffb49a]">
                  <p>
                    X{" "}
                    <span className="twitter-old font-light"> (Twitter) </span>{" "}
                  </p>
                  <RiTwitterXLine
                    size="2rem"
                    className="x-icon border rounded-[100%] p-[5px]"
                  />
                </div>
              </a>
              <a
                href="https://www.upwork.com/freelancers/~019a89bdcfcdae7dda"
                target="_blank" rel="noopener noreferrer"
                className="twitter-url w-fit"
              >
                <div className="upwork-profile inline-flex items-center gap-2 text-[1.25rem] md:text-[1.375rem] leading-[1.625rem] md:leading-[1.875rem] lg:text-[1.5rem] lg:leading-[2rem] xl:leading-[2rem] hover:text-[#ffb49a]">
                  <p>Upwork</p>
                  <SiUpwork
                    size="2rem"
                    className="upwork-icon border rounded-[100%] p-[5px]"
                  />
                </div>
              </a>
            </Fade>
          </div>
          <div className="footer-bottom absolute left-0 right-0 bottom-[1.5rem] px-0 xl:px-[4rem]">
            <div className="divider-line border-b-[0.0625rem] border-[#e5e5e5] mb-[1.4rem]"></div>
            <div className="footer-text flex items-center gap-1 text-[1rem] leading-[1.5rem] mb-[0.25rem] lg:text-[1.125rem] lg:leading-[1.5rem] px-[1.25rem] xl:px-0">
              <AiOutlineCopyrightCircle />
              <p className="footer-name">Emuobonuvie Pleasure</p>
            </div>
          </div>
          {/* modal */}
          {showModal && (
            <FormModal
              isLoading={isLoading}
              form={form}
              sendEmail={sendEmail}
              setShowModal={setSentModal}
              setSentModal={setSentModal}
              openBtn={openBtn}
            />
          )}

          {sentModal && <SentModal sentModalClose={sentModalClose} />}
          {errorMsg && <ErrorModal closeErrorModal={closeErrorModal} />}
        </div>
      </section>
    </footer>
  );
};

export default Footer;